<template>
  <aside>
    <b-navbar toggleable class="inner-left-sidebar">
      <div class="full-width dropdown">
        <b-navbar-toggle id="module_toggle_btn" target="modules">
          <template #default="{ expanded }">
            <span>Modules</span>
            <i v-if="expanded" class="fa fa-chevron-right"></i>
            <i v-else class="fa fa-chevron-right"></i>
            <!-- <i v-else class="fa fa-chevron-right"></i> -->
          </template>
        </b-navbar-toggle>
        <b-collapse id="modules" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item
              v-for="(mod, index) in modules"
              :key="index"
              :class="{ active: isModuleActive(mod.ModuleNumber) }"
              :to="{ name: 'single_module', params: { id: mod.ModuleNumber } }"
              >Module {{ mod.ModuleNumber }}</b-nav-item
            >
          </b-navbar-nav>
        </b-collapse>
      </div>
      <div class="full-width">
        <button
          type="button"
          class="navbar-toggler"
          :class="{ active: isActive4 }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'user_seminar' }"
            ><span>Seminars</span></router-link
          >
        </button>
      </div>
      <div class="full-width" >
        <button  v-if="loginUser.Status == 'PDC'"
          type="button"
          class="navbar-toggler"
          :class="{ active: $route.name === 'user_rsvp' }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'user_rsvp' }"
            ><span >RSVP </span></router-link
          >
        </button>
      </div>
      <div class="full-width">
        <button
          type="button"
          class="navbar-toggler"
          :class="{ active: isActive3 }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'user_webinars' }"
            ><span>Webinars</span></router-link
          >
        </button>
      </div>

      <div class="full-width">
        <button
          type="button"
          class="navbar-toggler"
          :class="{ active: isActive2 }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'skill_set' }"
            ><span>Skill Sets</span></router-link
          >
        </button>
      </div>
      <div class="full-width">
        <button
          type="button"
          class="navbar-toggler"
          :class="{ active: isActive1 }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'scott_notes' }"
            ><span>Scott Notes</span></router-link
          >
        </button>
      </div>
      <div class="full-width">
        <button
          type="button"
          class="navbar-toggler"
          :class="{ active: $route.name === 'materials' }"
        >
          <router-link
            class="nav-link seminar-nav-link"
            :to="{ name: 'materials' }"
            ><span>Materials</span></router-link
          >
        </button>
      </div>
    </b-navbar>
  </aside>
</template>

<script>
import userAPI from "../../userApi";
const mixin = {
  methods: {
    addClassesIfActive(routeNames, targetId) {
      const element = document.getElementById(targetId);
      if (!element) return;

      const isActive = routeNames.some((name) =>
        this.$route.matched.some((route) => route.name === name)
      );

      if (isActive) {
        element.classList.add("show");
        element.style.display = "";
      } else {
        element.classList.remove("show");
        element.style.display = "none";
      }
    },
  },
};
export default {
  name: "Sidebar",
  mixins: [mixin],
  props: {
    // Define the prop name and type
    // sidebarData: {
    //     type: Object,
    //     required: true
    // }
  },
  data() {
    return {
      modules: {},
    };
  },
  methods: {
    getAllModules() {
      userAPI.getAllModules(
        (res) => {
          this.modules = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    isModuleActive(moduleNumber) {
      return (
        this.$route.name === "single_module" &&
        this.$route.params.id == moduleNumber
      );
    },
  },
  computed: {
    isActive1() {
      return (
        [
          "scott_notes",
          "scott_notes_material",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/scott_notes") ||
        this.$route.path.startsWith("/scott_notes_material")
      );
    },
    isActive2() {
      return (
        [
          "skill_set",
          "skill_material",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/skill_set") ||
        this.$route.path.startsWith("/skill_material")
      );
    },
    isActive3() {
      return (
        [
          "user_webinars",
          "WebinarArchive",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/user_webinars") ||
        this.$route.path.startsWith("/WebinarArchive")
      );
    },
    isActive4() {
      return (
        [
          "user_seminar",
          "SeminarArchive",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/user_seminar") ||
        this.$route.path.startsWith("/SeminarArchive")
      );
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;
    this.getAllModules();
    this.$nextTick(() => {
      this.addClassesIfActive(["single_module"], "modules");

      // Use setTimeout to ensure the DOM is fully loaded
      setTimeout(() => {
        const closestNavbarToggler =
          document.getElementById("module_toggle_btn");

        // Only toggle the classes if the element is active
        if (closestNavbarToggler) {
          closestNavbarToggler.classList.remove("collapsed");
          closestNavbarToggler.setAttribute("aria-expanded", "true");
        }
      }, 3000);
    });
  },
};
</script>